function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 24 24",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "exclamation-circle",
    d: "M8,5.08C6.79,5.78,5.78,6.79,5.08,8C4.37,9.21,3.99,10.59,4,12c-0.01,1.41,0.36,2.79,1.07,4  c0.7,1.21,1.71,2.22,2.93,2.92c1.21,0.71,2.59,1.09,4,1.08c1.41,0.01,2.79-0.36,4-1.07c1.21-0.7,2.22-1.71,2.92-2.93  c0.71-1.21,1.09-2.59,1.08-4c0.01-1.41-0.36-2.79-1.07-4c-0.7-1.21-1.71-2.22-2.93-2.92C14.79,4.37,13.41,3.99,12,4  C10.59,3.99,9.21,4.37,8,5.08z M13.33,17c0,0.09-0.03,0.17-0.09,0.24c-0.06,0.07-0.14,0.1-0.23,0.1H11  c-0.18-0.01-0.32-0.16-0.33-0.34v-2c0.01-0.18,0.15-0.32,0.33-0.33h2c0.09,0,0.17,0.03,0.23,0.1c0.06,0.07,0.09,0.15,0.09,0.24v2  l0,0L13.33,17z M13.33,13.42c-0.01,0.07-0.05,0.14-0.11,0.18c-0.07,0.05-0.15,0.08-0.24,0.08H11c-0.09,0-0.18-0.03-0.25-0.08  c-0.06-0.04-0.1-0.11-0.1-0.18L10.5,6.94c-0.01-0.08,0.03-0.15,0.1-0.19c0.07-0.05,0.16-0.08,0.25-0.08h2.29  c0.09,0,0.18,0.03,0.25,0.08c0.07,0.04,0.11,0.11,0.1,0.19l-0.19,6.47l0,0L13.33,13.42z",
    style: {
      fill: "rgb(255, 209, 0)"
    },
    vectorEffect: "non-scaling-stroke"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.0eb55711.svg";
export { ForwardRef as ReactComponent };